<template>
  <div ref="player" class="player"/>
</template>

<script>
// @ts-ignore
import { SimdevPlayerBuilder } from '../../../public/player/player.js';

export default {
  props: {
    simple: {
      type: Boolean,
      default: false,
    },
    playlist: {
      type: Number,
      default: null,
    },
    channel: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    player: null,
  }),
  mounted () {
    this.getPlayer();
  },
  methods: {
    getPlayer () {
      this.player = (new SimdevPlayerBuilder({
        zoom: true,
        speed: true,
        control: {
          dynamic: true,
          allowPause: true,
        },
        title: {
          show: true,
          value: this.channel.address,
        },
        camera: {
          stream: this.channel.streamUrl,
        },
        buttons: {
          fullscreen: true,
        },
        archive: {
          enable: true,
          download: false,
          timeline: true,
          token: localStorage.getItem('user-token'),
          link: this.channel.link,
        },
      }))
        .build(this.$refs.player);
    },
    beforeDestroy () {
      this.player.call('destroy');
    },

    destroy () {
      if (this.player?.call) {
        this.player.call('destroy');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.player {
  width: 100%;
  height: 100%;
  position: absolute;
}
@media screen and (max-width: 700px) {
  .player {
    position: relative;
    width: 100%;
    max-width: 100%;
  }
}
</style>
